import { useAuth } from '../auth';
import ChangePassword from '../pages/ChangePassword';

// Blocks the whole routed UI behind the "set your password" screen while the signed-in account
// is still on its temporary password (mustChangePassword). The Header stays visible so the
// person can still log out.
export default function PasswordGate({ children }) {
  const { mustChangePassword } = useAuth();
  if (mustChangePassword) return <ChangePassword forced />;
  return children;
}
